import { css } from '@bts-web/utils-style-engine';
import { FC, PropsWithChildren } from 'react';

const TwoFaLayoutWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: { base: 'small', md: 'medium' },
        textAlign: 'center',
        width: '100%',
        margin: '0 auto',
        maxWidth: '600px',
        flex: '1',
        justifyContent: 'center',
        pt: { base: 'large', md: 'extra_large_4' },
        pb: { base: 'small', md: 'extra_large' },
        px: { base: 'large', md: 'extra_large' },
      })}
    >
      {children}
    </div>
  );
};

export { TwoFaLayoutWrapper };
